var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayerWarned(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 30.42,
    cy: 14.79,
    r: 5.51,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.43,28.7h4.06a0,0,0,0,1,0,0v3.13a2,2,0,0,1-2,2h0a2,2,0,0,1-2-2V28.7A0,0,0,0,1,31.43,28.7Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "24.2 22.72 38.53 22.72 38.53 45 28.42 45",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.32,22.72h0a4.21,4.21,0,0,0-3.88,2.57",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.63,22.72h0a2.1,2.1,0,0,1,2.1,2.1V43.51a0,0,0,0,1,0,0h0a4.21,4.21,0,0,1-4.21-4.21V24.82A2.1,2.1,0,0,1,40.63,22.72Z",
    transform: "translate(81.26 66.23) rotate(-180)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.84,18.16V15.81l-2.17-.35",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.21,
    cy: 17.25,
    r: 5.51,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "8.11 32.73 8.11 47.45 24.32 47.45 24.32 32.73",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.11,
    y1: 25.17,
    x2: 24.32,
    y2: 25.17,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.11,25.17h0A4.21,4.21,0,0,0,3.9,29.38V44A2.1,2.1,0,0,0,6,46.14H6A2.11,2.11,0,0,0,8.11,44",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.32,44.33a2.11,2.11,0,0,0,2.1,2.11h0a2.12,2.12,0,0,0,2.11-2.11V29.38a4.22,4.22,0,0,0-4.21-4.21h0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(12 42.79)",
    style: {
      fontSize: "15.099639892578125px",
      fontFamily: "Rubik-SemiBold, Rubik",
      fontWeight: 600,
      letterSpacing: "0.09998686298089068em"
    }
  }, "7"), /*#__PURE__*/React.createElement("line", {
    x1: 3.9,
    y1: 35.35,
    x2: 7.96,
    y2: 35.35,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.53,
    y1: 29.81,
    x2: 42.74,
    y2: 29.81,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.63,
    y1: 35.35,
    x2: 28.53,
    y2: 35.35,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.09,20.2a.56.56,0,0,1-.39-.15.6.6,0,0,1-.16-.41V17.21a.58.58,0,0,1,.16-.41.57.57,0,0,1,.39-.16h3.45a.6.6,0,0,1,.41.16.58.58,0,0,1,.15.41v2.43a.52.52,0,0,1-.56.56Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.22,13.73a.56.56,0,0,1-.41-.16.58.58,0,0,1-.15-.41v-10a.55.55,0,0,1,.15-.4.56.56,0,0,1,.41-.16h3.2a.53.53,0,0,1,.41.16.52.52,0,0,1,.16.4V13.16a.54.54,0,0,1-.16.41.53.53,0,0,1-.41.16Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerWarned);
export default __webpack_public_path__ + "static/media/PLAYER_WARNED.a702959ecafcc232dfdc9a6c35a992e2.svg";
export { ForwardRef as ReactComponent };